// extracted by mini-css-extract-plugin
export default {"card":"index_card__1hB1Z","tabs":"index_tabs__g312Y","item-title":"index_item-title__fkGFH","tag":"index_tag__g+JKQ"};